









































import { Component, Prop } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import AddJobFormEntityList from '@/components/add business objects/add-job/AddJobFormEntityList.vue';
import AddJob from '@/components/add business objects/addJob.vue';
import { AllEntities, FaultSymptomsApi, Org, OrgsApi, Product, ProductsApi, User } from '@/api';
import Vue from 'vue';
import { ParsingUtil } from '@/common/ParsingUtil';

@Component({
	components: { AddJob, AddJobFormEntityList },
	mixins: [validationMixin],
})
export default class AddJobModalsContainer extends Vue {
	@Prop()
	public product!: Product;

	@Prop()
	public partnerOrgs: Org[] | undefined;

	@Prop()
	public orgId!: number;

	public renderKey = 0;

	public contactableUsers: User[] = [];

	public faultReasonOptions: { text: string; value: any }[] = [];
	public sensorFaultReasonOptions: { text: string; value: any }[] = [];
	public transceiverFaultReasonOptions: { text: string; value: any }[] = [];

	private productApi: ProductsApi = new ProductsApi();
	private orgApi: OrgsApi = new OrgsApi();
	private faultSymptomsApi: FaultSymptomsApi = new FaultSymptomsApi();

	public async created() {
		await this.loadContactableUsers();
		await this.loadFaultSymptoms();
	}

	private async loadFaultSymptoms() {
		try {
			const response = await this.faultSymptomsApi.getFaultSymptoms();
			const faultSymptoms = (response.data.data ?? []).filter(
				x => x.productType == null || x.productType == this.product.type,
			);
			this.faultReasonOptions = (
				faultSymptoms.filter(x => x.entityType == AllEntities.Products) ?? []
			).map(x => ({ text: x.name, value: x.id }));
			this.sensorFaultReasonOptions = (
				faultSymptoms.filter(x => x.entityType == AllEntities.Sensors) ?? []
			).map(x => ({ text: x.name, value: x.id }));
			this.transceiverFaultReasonOptions = (
				faultSymptoms.filter(x => x.entityType == AllEntities.Transceivers) ?? []
			).map(x => ({ text: x.name, value: x.id }));
		} catch (e) {
			console.log('Error loading fault symptoms:', e);
		}
	}

	public async loadContactableUsers() {
		if (this.product.orgId == null) return;
		const productId: number | null = ParsingUtil.parseId(this.$route.params.productId);
		if (productId == null) {
			return;
		}
		try {
			const productData = await this.productApi.getProductById(productId, {
				params: { include: 'users' },
			});
			const orgData = await this.orgApi.getOrgUsers(this.product.orgId);
			const compiledUsers = [
				...((<Product & { users: any[] }>productData.data).users ?? []),
				...(orgData.data.data ?? []),
			];
			const uniqueIds = [...new Set(compiledUsers.map(user => user.id))];
			this.contactableUsers = uniqueIds.map(id => compiledUsers.find(user => user.id === id));
		} catch (e) {
			console.log(e);
		}
		this.reRender();
	}

	public loadJob() {
		this.$emit('loadJob');
	}

	public reRender() {
		this.renderKey > 0 ? this.renderKey-- : this.renderKey++;
	}
}
